import axiosInstance from './axiosInstance';
const API_URL = process.env.REACT_APP_API_URL;

export const getTenants = async () => {
  const resp = await axiosInstance.get(`${API_URL}/tenants`);
  return resp.data;
};

export const createTenant = async (data) => {
  const resp = await axiosInstance.post(`${API_URL}/tenants`, data);
  return resp.data;
};

export const updateTenant = async (id, data) => {
  const resp = await axiosInstance.put(`${API_URL}/tenants/${id}`, data);
  return resp.data;
};

export const deleteTenant = async (id) => {
  const resp = await axiosInstance.delete(`${API_URL}/tenants/${id}`);
  return resp.data;
};
